import {css} from 'lit-element'; export default css`.autocomplete-suggestion{padding:.2rem 1.2rem}.autocomplete-suggestion:focus,.autocomplete-suggestion:hover{background-color:var(--color-seashell);cursor:pointer}`;
    